export const SET_SEARCH_TEXT = 'SET_SEARCH_TEXT';

export const setSearchText = (state) => (dispatch) => {
    dispatch({ type: SET_SEARCH_TEXT, state });
};

export default {
    SET_SEARCH_TEXT,
    setSearchText,
};
